import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/project/batch',
    name: 'Home',
    component: Home,
    children: [
      { path: '/project/batch', name: 'project/batch', meta: { activeMenu: '/project/batch' }, component: () => import('@/views/project/Batch') },
      { path: '/project', name: 'project', meta: { keepAlive: false, activeMenu: '/project/batch' }, component: () => import('@/views/project/Project') },
      { path: '/project/award', name: 'project/award', meta: { activeMenu: '/project/batch' }, component: () => import('@/views/project/Award') },
      { path: '/project/add1', name: 'project/add1', meta: { activeMenu: '/project/batch' }, component: () => import('@/views/project/Add1') },
      { path: '/project/add2', name: 'project/add2', meta: { activeMenu: '/project/batch' }, component: () => import('@/views/project/Add2') },
      { path: '/project/add3', name: 'project/add3', meta: { activeMenu: '/project/batch' }, component: () => import('@/views/project/Add3') },
      { path: '/project/details', name: 'project/details', meta: { activeMenu: '/project/batch' }, component: () => import('@/views/project/Details') },
      { path: '/personal/batch', name: 'personal/batch', meta: { activeMenu: '/personal/batch' }, component: () => import('@/views/personal/Batch') },
      { path: '/personal', name: 'personal', meta: { activeMenu: '/personal/batch', keepAlive: false }, component: () => import('@/views/personal/Personal') },
      { path: '/personal/award', name: 'personal/award', meta: { activeMenu: '/personal/batch' }, component: () => import('@/views/personal/Award') },
      { path: '/personal/add1', name: 'personal/add1', meta: { activeMenu: '/personal/batch' }, component: () => import('@/views/personal/Add1') },
      // { path: '/personal/add2', name: 'personal/add2', component: () => import('@/views/personal/Add2') },
      { path: '/personal/details', name: 'personal/details', meta: { activeMenu: '/personal/batch' }, component: () => import('@/views/personal/Details') },
      // 消息通知
      { path: '/notification', name: 'notification', meta: { activeMenu: '/notification', keepAlive: true }, component: () => import('@/views/notification/Notification') },
      { path: '/notification/details', name: 'notification/details', meta: { activeMenu: '/notification' }, component: () => import('@/views/notification/Details') },
      { path: '/userCenter', name: 'UserCenter', meta: { activeMenu: '/userCenter' }, component: () => import('@/views/pwd/UserCenter') },
      { path: '/pwd', name: 'pwd', meta: { activeMenu: '/userCenter' }, component: () => import('@/views/pwd/Pwd') }
    ]
  },
  { path: '/login', name: 'login', component: () => import('@/views/Login.vue') },
  { path: '/awardInformation', name: 'awardInformation', component: () => import('@/views/AwardInformation.vue') },
  { path: '/awardCertificate', name: 'awardCertificate', component: () => import('@/views/AwardCertificate.vue') },
  { path: '/pdf', name: 'pdf', meta: { title: '证书' }, component: () => import('@/views/Pdf.vue') },
  { path: '/sign', name: 'sign', component: () => import('@/views/Sign.vue') },
  { path: '/retrieve', name: 'retrieve', component: () => import('@/views/Retrieve.vue') },
  { path: '*', component: () => import('@/views/404') }
]

const router = new VueRouter({
  mode: 'history',
  base: '/zjxkjj',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/pdf') {
    document.title = to.meta.title
  } else {
    document.title = '科技奖申报系统'
  }
  if (to.path === '/login' || to.path === '/retrieve' || to.path === '/sign' || to.path === '/awardInformation' || to.path === '/awardCertificate' || to.path === '/pdf') return next()
  if (!window.sessionStorage.getItem('login')) return next('/login')
  next()
})

export default router
